module.exports = __webpack_public_path__ + "media/custom/images/img15-5dd24ce62f9b2ab7927ccaa6671e27eb.png";